var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'text-center text-'+_vm.color+' my-'+_vm.my},[_c('b-spinner',{staticClass:"align-middle ml-2 mr-2"}),(_vm.showText)?_c('strong',[_vm._v("Loading...")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }